import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HOME_SECTIONS } from '../../data/home-sections';
import { ScrollSpyService } from '../../services/scroll-spy.service';

@Component({
  selector: 'app-footer',
  imports: [NgFor, RouterLink, RouterLinkActive],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  readonly sections = HOME_SECTIONS;
  readonly year = new Date().getFullYear();

  constructor(
    private readonly router: Router,
    public readonly scrollSpy: ScrollSpyService
  ) {}

  onLogoClick(): void {
    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    if (baseUrl !== '/') {
      this.scrollSpy.setPendingScrollTop();
      this.router.navigate(['/'], { replaceUrl: true });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  onSectionClick(id: string): void {
    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    if (baseUrl !== '/') {
      this.scrollSpy.setPendingSection(id);
      this.router.navigate(['/'], { replaceUrl: true });
      return;
    }

    this.scrollSpy.scrollTo(id);
  }

  get logoSrc(): string {
    return '/dark-mode-logo.webp';
  }
}
